import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Logout = ({ onLogout }) => {
    const navigate = useNavigate();

    useEffect(() => {
        const handleLogout = async () => {
            try {
                const response = await fetch('https://api.affordablecustomehr.com/psychology-ai-notes-generator/logout', {
                    method: 'POST',
                    credentials: 'include', // Include cookies with the request
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });

                if (response.ok) {
                    // Update app state and redirect
                    onLogout();
                    navigate('/home'); // Redirect to the sign-in page after logout
                } else {
                    console.error("Logout failed");
                }
            } catch (error) {
                console.error("Error during logout:", error);
            }
        };

        handleLogout();
    }, [onLogout, navigate]);

    return null; // No UI is necessary, as the logout is handled on mount
};

export default Logout;
